import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CoSelfcheckCheckinPage } from './co-selfcheck-checkin';
import { PipesModule } from '../../pipes/pipes.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { DirectivesModule } from '../../directives/directives.module';
import { ComponentsModule } from '../../components/components.module';
@NgModule({
  declarations: [
    CoSelfcheckCheckinPage,
  ],
  imports: [
    IonicPageModule.forChild(CoSelfcheckCheckinPage),
    PipesModule,
    NgxPaginationModule,
    DirectivesModule,
    ComponentsModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class CoSelfcheckCheckinPageModule {}



// WEBPACK FOOTER //
// ./src/pages/co-selfcheck-checkin/co-selfcheck-checkin.module.ts